import { send } from 'server';
import { getDateForIms } from 'js/hooks/useFormatter/helpers';

const tagValue = 'approved';

export const JUMIO_SET_UPLOAD_REQUIREMENT = 'JUMIO:UPLOAD_REQUIREMENT:SET';
export const JUMIO_SET_HAVE_COPY_ID_FAX = 'JUMIO:HAVE_COPY_ID_FAX:SET';

export const setUploadRequirement = (uploadRequirement) => ({
    type: JUMIO_SET_UPLOAD_REQUIREMENT,
    payload: uploadRequirement
});

export const setHaveCopyIDFax = (haveCopyIDFax) => ({
    type: JUMIO_SET_HAVE_COPY_ID_FAX,
    payload: haveCopyIDFax
});

export const getPlayerTag = (tag) => send({
    ID: 35547,
    responses: [35548, 35549],
    description: 'Get Player Tags Request',
    tagName: tag
});

export const getConfirmDate = () => send({
    ID: 35589,
    description: 'Get last beneficial owner confirm date',
    responses: [35590, 35591]
});

export const setConfirmDate = () => send({
    ID: 35586,
    lastBeneficialOwnerConfirmDate: getDateForIms(new Date()),
    responses: [35587, 35588],
    description: 'Set confirmation date'
});

export const setTagStatus = (beneficialAccountConfirmationTag) => send({
    tags: [{
        name: beneficialAccountConfirmationTag,
        value: tagValue,
        type: 'text'
    }],
    ID: 35544,
    responses: [35545, 35546],
    description: 'Set tag'
});
